import axios from "axios";
import { useMemo } from "react";
import { useQuery } from "react-query";
import {
  TransactionInventoryDetailsResponse,
  TransactionMaterial,
} from "../types";

const getTransactionInventory = (transactionId: number) =>
  axios
    .get<TransactionInventoryDetailsResponse>(
      "storages/getTransactionStorages",
      {
        params: { transactionId },
      }
    )
    .then(({ data }) => data);

const useTransactionInventory = (
  transactionId: number,
  warehouseId: number
) => {
  const { data: transactionInventory, isFetching } = useQuery(
    ["transactionInventory", transactionId],
    () => getTransactionInventory(transactionId)
  );

  const data: TransactionMaterial[] = useMemo(
    () =>
      transactionInventory?.storages.find((s) => s.storageId === warehouseId)
        ?.materials || [],
    [transactionInventory, warehouseId]
  );

  return { data, isFetching };
};

export default useTransactionInventory;
